import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Place } from "@dto/Place";
import { Event } from "@dto/Event";
import { Tour } from "@dto/Tour";
import { RootState } from "../store";
import { BBox } from "geojson";
import { Goal } from "@dto/Goal";
import { FeedPost } from "@dto/FeedPost";

export interface MapViewport {
  bbox: BBox | undefined;
  center: [number, number] | undefined;
  zoom: number | undefined;
}

export interface MapState {
  selectedEntity:
    | {
        entity: Place | Event | Tour | Goal | FeedPost;
        type: "Place" | "Event" | "Tour" | "Goal" | "FeedPost";
      }
    | undefined;
  viewport: MapViewport | undefined;
  mapTypeId: "roadmap" | "satellite" | "terrain";
}

const initialState: MapState = {
  selectedEntity: undefined,
  viewport: undefined,
  mapTypeId: "roadmap",
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setSelectedEntityAction: (
      state: MapState,
      action: PayloadAction<MapState["selectedEntity"]>,
    ) => {
      state.selectedEntity = action.payload;
    },
    setViewportAction: (
      state: MapState,
      action: PayloadAction<MapViewport>,
    ) => {
      state.viewport = action.payload;
    },
    setMapTypeIdAction: (
      state: MapState,
      action: PayloadAction<MapState["mapTypeId"]>,
    ) => {
      state.mapTypeId = action.payload;
    },
  },
});

// Selectors
export const selectSelectedEntity = (state: RootState) => {
  return state.map.selectedEntity;
};

export const selectViewport = (state: RootState) => {
  return state.map.viewport;
};

export const selectMapTypeId = (state: RootState) => {
  return state.map.mapTypeId;
};

export const {
  setSelectedEntityAction,
  setViewportAction,
  setMapTypeIdAction,
} = mapSlice.actions;

// eslint-disable-next-line import/no-default-export
export default mapSlice.reducer;
